import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import CronHelperText from './CronHelperText.react';
import isValidCron from '../../../util/isValidCron';

const EMPTY_CRON_EXPRESSION = '';

const validationState = (scheduleCron) => {
  if (scheduleCron) {
    return isValidCron(scheduleCron) ? 'success' : 'error';
  }
  return null;
};

const CronScheduleInput = ({ scheduleCron, updateScheduleCron }) => (
  <FormGroup className='saved-job-schedule-group' validationState={validationState(scheduleCron)}>
    <ControlLabel>Schedule Cron Expression</ControlLabel>
    <FormControl
      type='text'
      value={scheduleCron || EMPTY_CRON_EXPRESSION}
      onChange={updateScheduleCron}
      placeholder='"0 30 12 * * ?" = Run Every Day at 12:30 PM'
    />
    <CronHelperText />
  </FormGroup>
);

export default CronScheduleInput;

CronScheduleInput.propTypes = {
  scheduleCron: PropTypes.string,
  updateScheduleCron: PropTypes.func,
};

